module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-ig-449dba509df7d7e218051d4560aae822.png";